import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getHasFutureObjects, getTransportAccessibility } from '../../../selectors/newbuilding';
import { EMapService } from '../../../types/map';

export const useOnboardingMapServices = () => {
  const [services, setServices] = useState<Array<EMapService>>([]);

  // Микрофронт карты загружается лениво при доскролле и до загрузки не сообщает о доступных сервисах,
  // поэтому доступность сервисов определяется по данным стора
  const hasTransportAccessibilityRate = Boolean(useSelector(getTransportAccessibility));
  const hasFutureObjects = useSelector(getHasFutureObjects);

  const listener = useCallback((event: CustomEvent<EMapService[]>) => {
    if (Array.isArray(event.detail)) {
      setServices(event.detail);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('map-services:available:v1', listener);

    return () => document.removeEventListener('map-services:available:v1', listener);
  }, [listener]);

  return {
    hasFutureService: services.includes(EMapService.FutureInfrastructure) || hasFutureObjects,
    hasTransportAccessibilityService: services.includes(EMapService.TransportAccessibility) || hasTransportAccessibilityRate,
  };
};
